var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMood1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 477.14 885",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cb3d1f;}.cls-2{fill:#dd644a;}.cls-3{fill:#af280c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.24,
    y: 621.01,
    width: 434.4,
    height: 47.23,
    rx: 23.61,
    transform: "translate(498.87 1289.25) rotate(180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 238.57,
    cy: 238.57,
    r: 230.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M238.57,477.14c131.55,0,238.57-107,238.57-238.57S370.12,0,238.57,0,0,107,0,238.57,107,477.14,238.57,477.14Zm0-460.4c122.32,0,221.84,99.51,221.84,221.83S360.89,460.41,238.57,460.41,16.74,360.89,16.74,238.57,116.25,16.74,238.57,16.74Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 327.98,
    cy: 181.02,
    r: 29.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 160.67,
    cy: 181.02,
    r: 29.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M237.61,265.09a120.12,120.12,0,0,1,112.68,77.16,8.63,8.63,0,1,1-16.09,6.25,103.59,103.59,0,0,0-193.17,0,8.63,8.63,0,1,1-16.09-6.25A120.09,120.09,0,0,1,237.61,265.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.72,776.29V885H225.07V803.93H206.43V776.29Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMood1);
export default __webpack_public_path__ + "static/media/mood-1.530aff62.svg";
export { ForwardRef as ReactComponent };